import { render, staticRenderFns } from "./ApexCustomLabel.vue?vue&type=template&id=08b6fb0b&scoped=true&"
import script from "./ApexCustomLabel.vue?vue&type=script&lang=js&"
export * from "./ApexCustomLabel.vue?vue&type=script&lang=js&"
import style0 from "./ApexCustomLabel.vue?vue&type=style&index=0&id=08b6fb0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6fb0b",
  null
  
)

export default component.exports